module.exports = __webpack_public_path__ + "static/media/Admin-9.a7342d9a.png";